export default class ContractVersionItemRule {
  contractItemRuleId: string;

  ruleName: string;

  applyReadjustment: boolean;

  discount: number;

  discountType: string;

  applyDiscount: boolean;

  fee: number;

  feeType: string;

  applyFee: boolean;

  constructor(obj: any = {}) {
    this.contractItemRuleId = obj.contractItemRuleId || '';
    this.ruleName = obj.ruleName || '';
    this.applyReadjustment = obj.applyReadjustment || false;
    this.discount = obj.discount || 0;
    this.discountType = obj.discountType.value || '';
    this.applyDiscount = obj.applyDiscount || false;
    this.fee = obj.fee || 0;
    this.feeType = obj.feeType.value || '';
    this.applyFee = obj.applyFee || false;
  }

  public static of(obj: any = {}): ContractVersionItemRule {
    return new ContractVersionItemRule(obj || {});
  }

  public static ofList(obj: any[]): ContractVersionItemRule[] {
    return obj.map(this.of);
  }

  get isMoney(): boolean {
    return this.discountType === 'MONEY';
  }

  get isPercent(): boolean {
    return this.discountType === 'PERCENT';
  }
}
